import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ILocalization } from 'bernie-l10n';

import { SearchCriteriaModel } from 'stores/models';

import { LoyaltyMessagingModel } from 'models';
import { PropertySearch } from '__generated__/api/types';

import { classNames } from 'uitk-react-utils';
import { UitkHeading, UitkText } from 'uitk-react-text';
import { UitkStepIndicatorExperimental } from 'uitk-react-step-indicator-experimental';

import { HeaderMessageLink } from './header-message-link';
import { SWPToggle } from 'components/common/swp-toggle';

const classes = 'pwa-theme--grey-700 all-b-padding-one';

export enum ResultsHeaderMessageAlignment {
  Left = 'uitk-type-left',
  Center = 'uitk-type-center'
}

export interface ResultsHeaderProps {
  messageAlignment: ResultsHeaderMessageAlignment;
  headerSectionPaddingClasses?: string;
  summaryMessages?: PropertySearch.ResultsSummary[];
  isLoading: boolean;
  l10n: ILocalization;
  loyaltyMessagingModel?: LoyaltyMessagingModel;
  searchCriteria: SearchCriteriaModel;
}

export const ResultsHeader: React.FunctionComponent<ResultsHeaderProps> = props => {
  const { headerSectionPaddingClasses, messageAlignment, summaryMessages, isLoading, l10n, loyaltyMessagingModel, searchCriteria } = props;
  const multiItem = searchCriteria && searchCriteria.misId;
  const lob = multiItem ? 'multiItem' : 'hotels';

  if (isLoading) {
    return (
      <React.Fragment>
        {Boolean(multiItem) && <MultiItemStepIndicator l10n={l10n} className="all-b-padding-three" />}
        {Boolean(multiItem) && (
          <div className="all-b-padding-four">
            <UitkHeading level={1} size={500}>
              {l10n.formatText(`multiItem.hsrTitle.hc`)}
            </UitkHeading>
          </div>
        )}
        <p className={`${classes} ${messageAlignment} all-b-padding-two`}>{l10n.formatText(`${lob}.searchResults.loadingMessage.text`)}</p>
      </React.Fragment>
    );
  }

  const headerClasses = classNames(`tools__summary ${headerSectionPaddingClasses}`);

  return (
    <header className={headerClasses}>
      {Boolean(multiItem) && <MultiItemStepIndicator l10n={l10n} className="all-b-padding-three" />}
      {Boolean(multiItem) && (
        <div className="all-b-padding-four">
          <UitkHeading level={1} size={500}>
            {l10n.formatText(`multiItem.hsrTitle.hc`)}
          </UitkHeading>
        </div>
      )}
      <SWPToggle model={loyaltyMessagingModel} searchCriteria={searchCriteria} />
      <HeaderMessages messageAlignment={messageAlignment} summaryMessages={summaryMessages} />
    </header>
  );
};
ResultsHeader.displayName = 'ResultsHeader';

export interface MultiItemStepIndicatorProps {
  l10n: ILocalization;
  className;
}
export const MultiItemStepIndicator: React.FunctionComponent<MultiItemStepIndicatorProps> = ({ l10n, className }) => (
  <div className={className}>
    <UitkStepIndicatorExperimental
      steps={[
        { text: l10n.formatText(`multiItem.stepIndicator.hotel`), icon: `lob_hotels` },
        { text: l10n.formatText(`multiItem.stepIndicator.room`), icon: `bed` },
        { text: l10n.formatText(`multiItem.stepIndicator.car`), icon: `lob_cars` }
      ]}
      currentStep={0}
    />
  </div>
);
MultiItemStepIndicator.displayName = 'MultiItemStepIndicator';

export interface HeaderMessagesProps {
  messageAlignment: ResultsHeaderMessageAlignment;
  summaryMessages?: PropertySearch.ResultsSummary[];
}

export const HeaderMessages: React.FunctionComponent<HeaderMessagesProps> = props => {
  const { messageAlignment, summaryMessages } = props;

  if (!summaryMessages || summaryMessages.length === 0) {
    return null;
  }

  return (
    <div className="uitk-flex uitk-flex-column s-t-padding-one" data-stid="results-header-messages">
      {summaryMessages.map((summaryMessage, index) => {
        const { link, value } = summaryMessage;

        if (!value) {
          return null;
        }

        return (
          <div className={`${classes} ${messageAlignment}`} data-stid="results-header-message" key={`header-message-${index}`}>
            {link ? (
              <HeaderMessageLink {...summaryMessage} />
            ) : (
              <UitkText size={200} weight="bold">
                {value}
              </UitkText>
            )}
          </div>
        );
      })}
    </div>
  );
};
HeaderMessages.displayName = 'HeaderMessages';
